export default {
  title: 'HKLII 工具列',
  predictor: '港大人工智能律師<br/>販毒罪量刑估算程式',
  predictor_desc: '本程式利用人工智慧的力量來估算香港法例第134章《危險藥物條例》第4(1)(a)條中關於販運危險藥物罪的量刑。',
  sqe: '案件統計分析程式',
  sqe_desc: '開發團隊收集了多份人身傷害案件和販毒案件的判決書，構建了此統計查詢引擎，使用戶可以向統計查詢引擎提交查詢來有效地執行複雜的數據分析。',
  summary: '案件概要', // change to case highlight?
  summary_desc: '案件概要利用 AI 技術挑選判決書重點，讓用戶快速掌握 2020 年或以前人身傷害案案件的各方資訊。',
  tag_stats: '#統計',
  tag_summary: '#概要',
  tag_pi: '#人身傷害',
  tag_dt: '#販毒',
  tag_sentence: '#量刑',
}